var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkuploadfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.003,
    height: 64.93,
    viewBox: "0 0 101.003 64.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_170291",
    "data-name": "Path 170291",
    d: "M114.538,139.325c0-.271.045-.541.045-.812A26.294,26.294,0,0,0,88.5,112a26,26,0,0,0-23.515,15.105,13.356,13.356,0,0,0-6.042-1.465,13.527,13.527,0,0,0-13.257,11.385,20.544,20.544,0,0,0,6.493,39.905H75.287V158.894H64.42L82.5,140.024l18.081,18.848H89.716v18.036h24.867a18.795,18.795,0,0,0-.045-37.583Z",
    transform: "translate(-32 -112)",
    fill: "#c6c6c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkuploadfile);
export default __webpack_public_path__ + "static/media/bulkuploadfile.0d1c9e1b39415a3038399e452a93c968.svg";
export { ForwardRef as ReactComponent };